import type { ApiError } from './config';

export const isApiError = (error: unknown): error is ApiError => (error as ApiError).status !== undefined;
